// Initialisation and modifications for the Ajax Cart
  
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
  
$(document).ready(function() {
  $(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
    // Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
    timber.RightDrawer.open();
  });
  
  // adding the overlay below the drawer to visually separate it from the rest of the page
  $(document.body).on('beforeDrawerOpen.timber', function(evt, drawer) {
    $(".drawer_overlay").addClass("visible");
  });

  // removing the overlay below the drawer
  $(document.body).on('afterDrawerClose.timber', function(evt, drawer) {
    $(".drawer_overlay").removeClass("visible");
  });
  
  // bind mobile cart indicator to source and set initial value
  $('[data-cart-count-source]').bind("DOMSubtreeModified", function() { 
    $('[data-cart-count-mirror]')[0].innerHTML = $('[data-cart-count-source]')[0].innerHTML;
  });
  
  $('[data-cart-count-mirror]')[0].innerHTML = $('[data-cart-count-source]')[0].innerHTML;
  
  // Checkout terms checkbox
  $('body').on('click', '[name="checkout"]', function() {
    if ($('#agree-for-checkout').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("Bitte stimmen Sie unseren AGB, Widerrufsbelehrung und Datenschutzbestimmungen zu bevor Sie zur Kasse gehen.");
      return false;
    }
  });
  
  // open cart if url parameters require it.
  if (getUrlParameter("open_cart") == "true") {
    ajaxCart.load();
  }
});